import { PocketBaseClient } from "../PocketbaseClient.js";

export const cacheSongDataForPlaylist = async ({ recordName, playlistId }) => {
  console.log("CACHING SONG DATA FOR PLAYLIST", playlistId);
  const playlist = await PocketBaseClient.collection(recordName).getOne(
    playlistId,
    { expand: "songs" }
  );

  const songs = playlist.expand?.songs || [];

  const videoData = {};
  for (let song of songs) {
    if (song && song.videoId) {
      videoData[song.videoId] = song;
    }
  }

  await PocketBaseClient.collection(recordName).update(playlistId, {
    videoData,
    requestKey: null,
  });
};
